import { useEffect, useRef } from 'react';

import { isSSR } from 'app/packages/components';

/*
* Так как useEffect не работает на сервере, то сделать запрос к api не получится.
* При помощи этого хука можно делать запрос, и на клиенте, и на сервере.
*
* useComponentWillMount(() => {
*    fetch('/api/something')
* })
*
* @param callback – функция, которая будет вызвана при инициализации компонента
* */
const useComponentWillMount = <T>(callback: () => T): void => {
  const willMount = useRef(true);

  const executeCallback = () => {
    if (willMount.current) {
      willMount.current = false;

      callback();
    }
  };

  useEffect(() => {
    executeCallback();
  }, []);

  if (isSSR) {
    executeCallback();
  }
};

export default useComponentWillMount;
